/** @jsx jsx */
import React, { useContext, useEffect, useState } from 'react'
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import {
  getRiverRegionGroup,
  postRiverRegionGroup,
  deleteRiverRegionGroup,
  getAllRiverNames,
} from 'api/pgads'

import { connect } from 'react-redux'
import R from 'ramda'

import {
  getUtilityNameMap,
  getUnits,
  getUnitNameMap,
  getApiTargetInfo,
  getUnitTypeCode,
  getUnitGroups,
} from 'core/selectors'

import GenericEditScreen, {
  RowButtons,
  RowContainer,
} from 'core/component/GenericEditScreen'
import moment from 'moment'
import { DatePicker } from 'antd'
import { Filler } from '../../../core/screen-util'

import { DatePickerContext, ErrorContext } from 'context'
import { strCol, dateCol } from '@integec/grid-tools/lib/cols'
import RiveSystemRegionGroupModal from './RiverSystemRegionModal'
const GroupLabel = styled.div`
  font-weight: bold;
  font-size: 1.4em;
`
const CountLabel = styled.div`
  font-size: 1.2em;
  color: #777;
  margin-left: 1em;
`
const DateLabel = styled.div`
  font-size: 1em;
  color: #777;
  margin-left: 1em;
`

const RiverSystemRegion = props => {
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { setError } = useContext(ErrorContext)
  const [riverList, setRiverList] = useState([])
  useEffect(
    _ => {
      getAllRiverNames(props.targetInfo).fork(setError, setRiverList)
    },
    [props.targetInfo, setError]
  )

  const renderModal = ({ hideModal, modalInfo, list, ...rest }) => (
    <RiveSystemRegionGroupModal
      riverList={riverList}
      hide={hideModal}
      data={modalInfo}
      availableUnits={props.availableUnits}
      unitNameMap={props.unitNameMap}
      utilityNameMap={props.utilityNameMap}
      list={list}
      {...props}
      {...rest}
    />
  )
  const renderRow = ({ item, popModal, style, onDelete }) => (
    <RowContainer style={style}>
      <GroupLabel>{item.region}</GroupLabel>
      <CountLabel>{item.river.length} River</CountLabel>
      <DateLabel>
        <b>Effective Date :</b>{' '}
        {moment(item.effectiveDate).format('MM/DD/YYYY')}
      </DateLabel>
      <Filler />
      <RowButtons
        item={{
          ...item,
          effectiveDate: moment(item.effectiveDate).format('YYYY-MM-DD'),
        }}
        onDelete={onDelete}
        popModal={popModal}
        duplicateClicked={() =>
          popModal({
            ...item,
            isNew: true,
            effectiveDate: moment(),
            isDuplicate: true,
          })
        }
      />
    </RowContainer>
  )

  const exportFunc = data => {
    const exData = (data || []).map(u =>
      (u.river || []).map(un => ({
        region: u.region,
        effectiveDate: u.effectiveDate,
        river: un,
      }))
    )
    const flatData = R.flatten(exData)
    return R.sortWith([R.ascend(R.compose(R.toLower, R.prop('region')))])(
      flatData
    )
  }

  const ExportHeader = [
    strCol({
      ident: 'region',
      display: 'Region Group Name',
      width: 200,
    }),
    dateCol({
      ident: 'effectiveDate',
      display: 'Effective Date',
    }),
    strCol({
      ident: 'river',
      display: 'River',
      width: 450,
      isRequired: true,
      sortOrder: 'asc',
      // dataFormatter: ({ value }) => props.utilityNameMap[value] || value,
    }),
  ]

  return (
    <GenericEditScreen
      // sortOnData={sortOnData}
      isExportAvaliable
      exportHeaders={ExportHeader}
      exportFunc={exportFunc}
      sort={data =>
        data.sort((d1, d2) =>
          d1 === undefined || d2 === undefined
            ? 1
            : d1.region.toLowerCase() <= d2.region.toLowerCase()
            ? -1
            : 1
        )
      }
      title="Region River System"
      loadApiTask={getRiverRegionGroup}
      createApiTask={postRiverRegionGroup}
      updateApiTask={postRiverRegionGroup}
      deleteApiTask={deleteRiverRegionGroup}
      renderModal={renderModal}
      renderRow={renderRow}
      rowHeight={50}
      listHeightOffset={260}
      acceptFilter={item => filterText =>
        filterText == null ||
        (item.region || '').toLowerCase().includes(filterText.toLowerCase())}
      criteria={() => (
        <div style={{ marginLeft: '30px' }}>
          <label>Effective Date : </label>
          <DatePicker
            allowClear={false}
            format="MM/DD/YYYY"
            value={selectedDate}
            onChange={setSelectedDate}
          />
        </div>
      )}
      getLoadCriteria={() => selectedDate}
      dataMatcher={d1 => d2 =>
        d1.region === d2.region && d1.effectiveDate === d2.effectiveDate}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  availableUnits: getUnits(state),
  unitNameMap: getUnitNameMap(state),
  utilityNameMap: getUtilityNameMap(state),
  unitTypeCode: getUnitTypeCode(state),
  unitGroups: getUnitGroups(state),
})

export default connect(mapStateToProps)(RiverSystemRegion)
